import React from 'react';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import {withNamespaces} from 'react-i18next';

const DeleteModal = ({onCancel, t, onConfirm, ...props}) => (
  <Dialog
    title={t('deleteModal.delete')}
    modal
    {...props}
    actions={[
      <FlatButton label={t('deleteModal.cancel')} onClick={onCancel} />,
      <FlatButton label={t('deleteModal.yes')} primary onClick={onConfirm} />,
    ]}>
    {t('deleteModal.deleteText')}
  </Dialog>
);

export default withNamespaces()(DeleteModal);



// WEBPACK FOOTER //
// ./src/components/DeleteModal.js